import React, { Component } from "react";
import axios from "axios";
import { connect } from "react-redux";
import Server from "../Server.js";
import Header from "../Header.js";
import { SelectButton } from "primereact/selectbutton";
import { ToggleButton } from "primereact/togglebutton";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { Progress, Space, Popover  } from "antd";
import { Button } from "primereact/button";
import moment from "moment-jalaali";

import { Route, Link, Navigate } from "react-router-dom";
import { Toast } from "primereact/toast";
import Swiper from "react-id-swiper";
import { ProgressSpinner } from "primereact/progressspinner";
import Num2persian from 'num2persian';

const params5 = {
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  loop: 1,
  centeredSlides: true,
  slidesPerView: "auto",
  coverflowEffect: {
    rotate: 50,
    stretch: 0,
    depth: 100,
    modifier: 1,
    slideShadows: true,
  },
  pagination: {
    el: ".swiper-pagination",
  },
};

class Reserve extends React.Component {
  constructor(props) {
    super(props);
    this.myRef = React.createRef(); // Create a ref object
    this.Server = new Server();
    this.SetReserve = this.SetReserve.bind(this);
    this.toast = React.createRef();
    this.state = {
      activePage: 1,
      TransferAccount: this.Server.getSystem() ? this.Server.getSystem().TransferAccount : "2045800",
      CurrentTab: 1,
      showDiv: 0,
      credit: 0,
      number:
        window.location.href && window.location.href.split("number=")[1]
          ? window.location.href.split("number=")[1].split("&")[0]
          : null,
      bankCallBack: window.location.href
        ? window.location.href.split("bankCallBack=")[1]
        : null,
      Price: 0,
      userReservedItem: [],
      userChecked: [],
      mounth: [
        "فروردین",
        "اردیبهشت",
        "خرداد",
        "تیر",
        "مرداد",
        "شهریور",
        "مهر",
        "آبان",
        "آذر",
        "دی",
        "بهمن",
        "اسفند",
      ],
      key: [
        "one",
        "two",
        "three",
        "four",
        "five",
        "six",
        "seven",
        "eight",
        "nine",
        "ten",
        "eleven",
        "toelve",
      ],
      absoluteUrl: this.Server.getAbsoluteUrl(true),
      url: this.Server.getUrl(),
      AppAddress: this.Server.getAppAddress(),
      System: this.Server.getSystem(),
    };
  }

  componentDidMount() {
    /*if(this.props.username != "5" && this.props.username != "2" && this.props.username != "423" && this.props.username != "358"){
      this.toast.current.show({ severity: 'warn', summary: <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>, detail: <div className="iranyekanwebmedium">پردازش در حال پیاده سازی است</div>, life: 4000 });
      return;
    }*/
    let m = moment();
    let CYear = m.jYear();
    let CMounth = m.jMonth() + 1;
    let CDay = m.jDate();
    this.setState({
      CYear: CYear,
      CMounth: CMounth,
      CDay: CDay,
      UserMobile: localStorage.getItem("UserMobile") || "",
      username: this.props.username || localStorage.getItem("UserMobile") || "",
      UserFullName: localStorage.getItem("UserFullName") || "",
      ShowLoading: true
    });
    this.GetReserve(true);
  }

  AfterPayment(userchecked) {
    let that = this;
    const urlParams = new URLSearchParams(window.location.href);
    let param = {
      Authority: urlParams.get("Authority"),
      codeMelli: urlParams.get("codeMelli"),
      username: urlParams.get("username"),
      Amount: parseInt(urlParams.get("Amount")),
      reqTime: urlParams.get("Time"),
      reqDate: urlParams.get("Date"),
      systemId:  this.state.System ?  this.state.System.id : null
    };
    this.setState({
      output: "",
    });
    let SCallBack = function (response) {
      //response.data.result.RefID
      if (response.data.result.RefID) {
        that.SetReserve(1, 1, userchecked);
       /* const userChecked = that.state.userChecked;
        that.setState(
          {
            userChecked: userChecked,
          },
          () => {
            that.SetReserve(1, 1);
          }
        );*/
        that.toast.current.show({
          severity: "success",
          summary: <div className="iranyekanwebmedium">پرداخت انجام شد</div>,
          detail: (
            <div className="iranyekanwebmedium">
              <div>رسید تراکنش : {response.data.result.RefID}</div>
            </div>
          ),
          life: 4000,
        });
      } else {
        that.toast.current.show({
          severity: "error",
          summary: (
            <div className="iranyekanwebmedium">خطا در انجام تراکنش</div>
          ),
          detail: (
            <div className="iranyekanwebmedium">
              <div>پرداخت انجام نشد</div>
            </div>
          ),
          life: 4000,
        });
      }
    };
    let ECallBack = function (error) {
      console.log(error);
    };
    if (this.state.bankStatus === "NOK") {
      param["Status"] = "NOK";
      this.setState({
        paymentMessage: "عملیات پرداخت با خطا مواجه شد",
        paymentSuccess: false,
      });
    } else {
      param["Status"] = "OK";
      this.Server.send("MainApi/payment3Callback", param, SCallBack, ECallBack, null, true);
    }
  }

  GetReserve(first) {
    let that = this;
    const urlParams = new URLSearchParams(window.location.href);
    let param = {
      username: urlParams.get("username"),
      Amount: parseInt(urlParams.get("Amount")),
      Time: urlParams.get("Time"),
      Date: urlParams.get("Date"),
      systemId:  this.state.System ?  this.state.System.id : null
    };
    let SCallBack = function (response) {
      that.setState({
        GridDataReserve: response.data.result[0],
        IsConfirm: response.data.result[0].confirm,
      });
      if (that.state.bankCallBack && first) {
        that.Server.send("AdminApi/getExtraPayment", param, (resp)=>{
          const userchecked = resp.data.result[0] ? resp.data.result[0].recordSale : [];
          that.setState(
            {
              userChecked: userchecked,
            },
            () => {
              that.AfterPayment(userchecked);
            }
          );
        }, ()=>{

        }, null, true);
      } 
      that.GetReserveDetails();
    };
    let ECallBack = function (error) {
      
    };
    this.Server.send("AdminApi/GetReserve", {
      token: localStorage.getItem("api_token"),
      number: this.state.number,
    }, SCallBack, ECallBack, null, true);
  }

  GetReserveDetails() {
    let that = this;
    let param = {
      number: this.state.number,
    };
    let SCallBack = function (response) {
      let Mounth = {
        one: [],
        two: [],
        three: [],
        four: [],
        five: [],
        six: [],
        seven: [],
        eight: [],
        nine: [],
        ten: [],
        eleven: [],
        toelve: [],
      };
      let currentUserReserved = 0;
      let userReservedItem = [];
      let userChecked = [];
      let RemainPayment = false;
      let week = [
        "یکشنبه",
        "دوشنبه",
        "سه شنبه",
        "چهارشنبه",
        "پنج شنبه",
        "جمعه",
        "شنبه",
      ];
      for (let item of response.data.result) {
        if (
          item.username &&
          item.username == that.state.username &&
          item.checked
        ) {
          item.old = 1;
          userReservedItem.push(item);
          userChecked.push(item);
          if (
            !that.state.IsConfirm ||
            (item.UserConfirmed && item.SystemConfirmed)
          )
            currentUserReserved++;
          if (
            that.state.IsConfirm &&
            item.SystemConfirmed &&
            !item.UserConfirmed
          ) {
            RemainPayment = true;
          }
        }
        let index = parseInt(item.day.split("_")[1]) - 1;
        item.Mounth = that.state.mounth[index];
        item.MounthNum = parseInt(item.day.split("_")[1]);
        item.Day = item.day.split("_")[2];
        item.Year = item.day.split("_")[0];
        item.price = item.price || that.state.GridDataReserve.price;
        item.priceWord = Num2persian(item.price.substr(0,item.price.length-1));
        item.value = item.day;
        item.label = item.Day + "\n" + week[item.weekName] ;
        item.week = week[item.weekName];
        if (item.MounthNum == 1) Mounth.one.push(item);
        if (item.MounthNum == 2) Mounth.two.push(item);
        if (item.MounthNum == 3) Mounth.three.push(item);
        if (item.MounthNum == 4) Mounth.four.push(item);
        if (item.MounthNum == 5) Mounth.five.push(item);
        if (item.MounthNum == 6) Mounth.six.push(item);
        if (item.MounthNum == 7) Mounth.seven.push(item);
        if (item.MounthNum == 8) Mounth.eight.push(item);
        if (item.MounthNum == 9) Mounth.nine.push(item);
        if (item.MounthNum == 10) Mounth.ten.push(item);
        if (item.MounthNum == 11) Mounth.eleven.push(item);
        if (item.MounthNum == 12) Mounth.toelve.push(item);
      }

      let showDiv = 0;
      if (Mounth.toelve.length > 0) showDiv = 11;
      if (Mounth.eleven.length > 0) showDiv = 10;
      if (Mounth.ten.length > 0) showDiv = 9;
      if (Mounth.nine.length > 0) showDiv = 8;
      if (Mounth.eight.length > 0) showDiv = 7;
      if (Mounth.seven.length > 0) showDiv = 6;
      if (Mounth.six.length > 0) showDiv = 5;
      if (Mounth.five.length > 0) showDiv = 4;
      if (Mounth.four.length > 0) showDiv = 3;
      if (Mounth.three.length > 0) showDiv = 2;
      if (Mounth.two.length > 0) showDiv = 1;
      if (Mounth.one.length > 0) showDiv = 0;
      try{
        showDiv = parseInt(new Date().toLocaleDateString('fa-IR').split("/")[1].replace(/[۰-۹]/g, d => '۰۱۲۳۴۵۶۷۸۹'.indexOf(d)))-1
      }catch(e){
      }
      that.setState({
        TableRecords: response.data.result,
        showDiv: showDiv,
        Mounth: Mounth,
        Allow: currentUserReserved < that.state.GridDataReserve.maxDay,
        userReservedItem: userReservedItem,
        checkedCount: userChecked.length,
        userChecked: userChecked,
        RemainPayment: RemainPayment,
        ShowLoading: false
      });
      that.GetAccounts();
    };
    let ECallBack = function (error) {
    };
    this.Server.send("AdminApi/GetReserveDetails", param, SCallBack, ECallBack, null, true);
  }
  GetAccounts(RefreshVam) {
    let that = this;
    if (!this.props.username) {
      return;
    }
    let SCallBack = function (response) {
      let data = [];
      let resp = [];
      for (let i = 0; i < response.length; i++) {
        resp[i] = response[i].children;
      }
      for (let i = 0; i < resp.length; i++) {
        for (let j = 0; j < resp[i].length; j++) {
          if (resp[i][j].name == "A_Kind") {
            if (resp[i][j].value == "5") data.push(resp[i]);
          }
        }
      }
      let AccList = [];
      for (let i = 0; i < data.length; i++) {
        AccList[i] = {
          value: data[i][1].value,
          label: data[i][3].value + "(" + data[i][1].value + ")",
        };
      }
      AccList.push({
        value: "zarinpal",
        label: "پرداخت از حساب بانکی",
      });
      that.setState({
        AccList: AccList,
        AccountNumber: AccList.length > 1 ? null : AccList[0].value,
      });
    };
    let ECallBack = function (error) {
    };

    var param =
      '{CommandNo : "3" , AccountNo: "' +
      that.props.account +
      '",Param1: "' +
      that.props.password +
      '" }';
    that.Server.sendRaymand(
      "" + that.props.ip + "/MobileBank.aspx/MobileBankSp",
      param,
      SCallBack,
      ECallBack,
      {
        ip: that.props.ip,
      }
    );
  }

  setOffCode(){
    let that = this;
    let username = (this.state.UserMobile || this.props.mobile);
    username = username.charAt(0) == "0"
        ? username.substr(1)
        : username;
    let param = {
      username: username ,
      offCode: this.state.offCode
    };
    let SCallBack = function (response) {
      if(response.data.error){
        that.toast.current.show({
          severity: "warn",
          summary: (
            <div className="iranyekanwebmedium">عدم دسترسی</div>
          ),
          detail: (
            <div className="iranyekanwebmedium">{response.data.error}</div>
          ),
          life: 4000,
        });
      }else{

        const output = response.data.output;
        let finalAmount = 0;
        let off = 0;
        if(output.percent){
          off = (parseInt(that.state.Price) * output.percent) / 100 < parseInt(output.Amount) ? ((parseInt(that.state.Price) * output.percent) / 100) : parseInt(output.Amount)
        }else{
          off = parseInt(output.Amount);
        }
        finalAmount =  parseInt(that.state.Price) - off

        that.setState({
          OriginalPrice: that.state.Price,
          Price : finalAmount,
          OffCodeAccept: true,
          offAmount : off
        })
        that.toast.current.show({
          severity: "success",
          summary: (
            <div className="iranyekanwebmedium">تایید کد</div>
          ),
          detail: (
            <div className="iranyekanwebmedium">کد تخفیف با موفقیت اعمال شد</div>
          ),
          life: 4000,
        });
        debugger;
        //Todo: کم کردن مبلغ تخفیف با فرمول مشحص از مبلغ کل قابل پرداخت

      }
      
    };
    let ECallBack = function (error) {
    };
    this.Server.send("AdminApi/checkOffCode", param, SCallBack, ECallBack, null, true);
  }

  SetReserve(verify, end , userchecked = []) {
    let that = this;
    let days = [];
    let Price = 0;
    if (this.state.ShowLoading) return;
    let extra = "";
    let SystemConfirmed = false;
    let Count = 0;
    for (let i = 0; i < userchecked.length; i++) {
      if (userchecked[i].old != "1") {
        Count++;
        Price += parseInt(userchecked[i].price);
        days.push(userchecked[i].day);
        extra +=
        userchecked[i].Day +
          " " +
          userchecked[i].Mounth +
          " " +
          userchecked[i].Year +
          "\n";
      } else {
        if (
          userchecked[i].SystemConfirmed &&
          !userchecked[i].UserConfirmed
        ) {
          Count++;
          SystemConfirmed = true;
          Price += parseInt(userchecked[i].price);
          days.push(userchecked[i].day);
          extra +=
          userchecked[i].Day +
            " " +
            userchecked[i].Mounth +
            " " +
            userchecked[i].Year +
            "\n";
        }
      }
    }
    
    // if(end){
    //   localStorage.removeItem("userChecked");
    // }

    if (!end && this.state.GridDataReserve && userchecked.length < this.state.GridDataReserve.minDay) {
      that.toast.current.show({
        severity: "warn",
        summary: (
          <div className="iranyekanwebmedium">محدودیت روز</div>
        ),
        detail: (
          <div className="iranyekanwebmedium">حداقل {this.state.GridDataReserve.minDay} روز را انتخاب کنید</div>
        ),
        life: 4000,
      });
      return;
    }
    if (!end && this.state.GridDataReserve && userchecked.length > this.state.GridDataReserve.maxDay) {
      that.toast.current.show({
        severity: "warn",
        summary: (
          <div className="iranyekanwebmedium">محدودیت روز</div>
        ),
        detail: (
          <div className="iranyekanwebmedium">امکان رزرو بیشتر از  {this.state.GridDataReserve.maxDay} روز وجود ندارد</div>
        ),
        life: 4000,
      });
      return;
    }

    /*
    if(!this.props.username)
      return;*/
    if (!verify) {
      this.setState({
        SystemConfirmed: SystemConfirmed,
        Price: Price,
        ReserveDialog: 1,
      });
      return;
    }
    if (
      !this.state.AccountNumber &&
      this.props.username &&
      (!this.state.IsConfirm || SystemConfirmed)
    ) {
      that.toast.current.show({
        severity: "warn",
        summary: (
          <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>
        ),
        detail: (
          <div className="iranyekanwebmedium">حساب خود را انتخاب کنید</div>
        ),
        life: 4000,
      });
      return;
    }
    if (!this.props.username && !this.state.UserMobile) {
      that.toast.current.show({
        severity: "warn",
        summary: (
          <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>
        ),
        detail: (
          <div className="iranyekanwebmedium">
            شماره تلفن همراه را وارد کنید
          </div>
        ),
        life: 4000,
      });
      return;
    }
    if (this.state.UserMobile) {
      localStorage.setItem("UserMobile", this.state.UserMobile);
      localStorage.setItem("UserFullName", this.state.UserFullName);
    }
    if (!end && (!that.state.IsConfirm || SystemConfirmed)) {
      if (that.props.username && that.state.AccountNumber !== "zarinpal")
        that.Transfer();
      else that.savePayment(null, 0);
      return;
    }
    let param = {
      token: localStorage.getItem("api_token"),
      number: this.state.number,
      price: this.state.Price,
      offAmount : this.state.OffCodeAccept ? this.state.offAmount : 0,
      extra: extra,
      days: days,
      username: this.state.username,
      mobile:
        this.props.mobile && this.props.mobile.length > 10
          ? this.props.mobile.substring(1)
          : this.props.mobile || this.state.UserMobile,
      account: this.props.account,
      checked: true,
      name: this.props.fullname,
      type: this.state.GridDataReserve.name,
      IsConfirm: this.state.IsConfirm,
      UserConfirmed: SystemConfirmed,
      SystemConfirmed: SystemConfirmed,
      managerMobile: this.state.GridDataReserve.managerMobile,
    };
    let SCallBack = function (response) {
      that.setState({
        ReserveDialog: false,
        ShowLoading: true
      })
      that.GetReserve();
    };
    let ECallBack = function (error) {
    };
    this.Server.send("AdminApi/ReserveForUser", param, SCallBack, ECallBack, null, true);
  }
  Transfer() {
    let that = this;
    let ip = that.props.ip || that.state.AppAddress;
    if (!this.state.AfterSend) {
      let SCallBack = function (response) {
        let resp = [];
        for (let i = 0; i < response.length; i++) {
          resp[i] = response[i].children;
        }
        if (resp[0][0].name == "ERROR") {
          that.setState({
            AccDialog: false,
            ShowLoading: false,
          });
          that.toast.current.show({
            severity: "warn",
            summary: (
              <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>
            ),
            detail: (
              <div className="iranyekanwebmedium">{resp[0][0].value}</div>
            ),
            life: 4000,
          });

          return;
        }
        that.setState({
          ticketNo: resp[0][0] ? resp[0][0].value : "",
          AfterSend: true,
        },()=>{
          that.savePayment(null, 0);
        });
        
      };
      let ECallBack = function (error) {
        that.setState({
          ShowLoading: false,
        });
      };
      that.setState({
        ShowLoading: true,
      });

      let amount = this.state.Price.toString().replace(/,/g, "");
      let Param1 = this.state.TransferAccount + ";" + amount + ";";
      var param =
        '{CommandNo : "72" , AccountNo: "' +
        that.state.AccountNumber +
        '",Param1: "' +
        Param1 +
        '" }';

      that.Server.sendRaymand(
        "" + ip + "/MobileBank.aspx/MobileBankSp",
        param,
        SCallBack,
        ECallBack,
        {
          ip: that.props.ip,
        }
      );
    }
    if (this.state.AfterSend) {
      let SCallBack = function (response) {
        let resp = [];
        for (let i = 0; i < response.length; i++) {
          resp[i] = response[i].children;
        }
        if ((resp[0][0] && resp[0][0].name == "ERROR") || !resp[0][1]) {
          that.setState({
            AccDialog: false,
          });
          that.toast.current.show({
            severity: "warn",
            summary: (
              <div className="iranyekanwebmedium">خطا در برقراری ارتباط</div>
            ),
            detail: (
              <div className="iranyekanwebmedium">{resp[0][0].value}</div>
            ),
            life: 4000,
          });

          return;
        }

        that.setState({
          SanadNumber: resp[0][0] ? resp[0][0].value : "",
          ResidNumber: resp[0][1] ? resp[0][1].value : "",
          AccDialog: false,
          RefId: resp[0][1] ? resp[0][1].value : "",
          ShowLoading: false,
        },()=>{
          that.savePayment(1, 1);
        });
        

        that.toast.current.show({
          severity: "success",
          summary: <div className="iranyekanwebmedium">پرداخت انجام شد</div>,
          detail: (
            <div className="iranyekanwebmedium">
              <div>سند : {resp[0][0] ? resp[0][0].value : ""}</div>
              <div>رسید تراکنش : {resp[0][1] ? resp[0][1].value : ""}</div>
            </div>
          ),
          life: 4000,
        });
      };
      let ECallBack = function (error) {
        that.setState({
          ShowLoading: false,
        });
      };
      that.setState({
        AfterSend: false,
        ShowLoading: true,
      });
      var FDesLocalChanged = "رزرو اتاق";
      let amount = this.state.Price.toString().replace(/,/g, "");
      var Param1 =
        this.props.username +
        ";" +
        this.state.AccountNumber +
        ";" +
        this.state.TransferAccount +
        ";" +
        amount +
        ";" +
        FDesLocalChanged +
        ";;;0;0;;";
      var param =
        '{CommandNo : "73" , AccountNo: "' +
        that.state.ticketNo +
        '",Param1: "' +
        Param1 +
        '" }';
      that.Server.sendRaymand(
        "" + that.props.ip + "/MobileBank.aspx/MobileBankSp",
        param,
        SCallBack,
        ECallBack,
        {
          ip: that.props.ip,
        }
      );
    }
  }
  Payment() {
    let that = this;
    let url = this.state.url + "payment3";
    let username = (this.state.UserMobile || this.props.mobile)
    username =  username.charAt(0) == "0" ? username.substr(1) : username;
    let param = {
      Amount: parseInt(
        this.state.Price.toString().substring(
          0,
          this.state.Price.toString().length - 1
        )
      ),
      desc: "رزرو اتاق",
      username: username,
      address: `${this.state.AppAddress}/#/Reserve?number=${this.state.number}`,
      recordSale: this.state.userChecked || [],
      offAmount : this.state.OffCodeAccept ? this.state.offAmount : 0
    };

    axios
      .post(url, param)
      .then((response) => {
        let res;
        res = response.data.result ? response.data.result : {};
        if (response.data.url) {
          window.location = response.data.url;
          //window.location = `https://r-bank.ir/12802045800_${this.state.Price}_${encodeURIComponent('رزرو اتاق')}_${this.state.mobile}_8`;
          return;
        } else {
          this.toast.current.show({
            severity: "error",
            summary: (
              <div>
                {" "}
                {res.Message} <br />
                برای اتمام خرید در زمان دیگری مراجعه کنید یا از طریق حساب صندوق
                پرداخت کنید
              </div>
            ),
            life: 8000,
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }
  savePayment(edit, status) {
    let that = this;
    let username = (this.state.UserMobile || this.props.mobile)
    username =  username.charAt(0) == "0"
    ? username.substr(1) : username;
    if (!edit) {
      if (
        that.props.username &&
        that.state.AccountNumber !== "zarinpal"
      )
        that.Transfer();
      else that.Payment();
    } else {
      that.SetReserve(1, 1, that.state.userChecked);
    }
  }

  render() {
    if (this.state.page) {
      return <Navigate to={this.state.page} />;
    }
    return (
      <div style={{ height: "100%" }}>
        <Header ComponentName="رزرو ویلا" close={this.state.bankCallBack ? true : false} />
        <Toast
          ref={this.toast}
          position="top-right"
          style={{ fontFamily: "iranyekanwebmedium", textAlign: "right" }}
        />
        {!this.state.Allow && this.state.showDiv != 0 && (
          <div
            style={{ backgroundColor: "#ff6f6f", color: "#fff", marginTop: 10 }}
          >
            <div>
              <div
                className="iranyekanwebmedium"
                style={{ textAlign: "center" }}
              >
                سهیه رزرو اکانت شما به پایان رسیده است
              </div>
            </div>
            <div>
              {this.state.IsConfirm &&
              this.state.userReservedItem[0] &&
              !this.state.userReservedItem[0].SystemConfirmed ? (
                <div
                  className="iranyekanwebmedium"
                  style={{ textAlign: "center" }}
                >
                  {" "}
                  درخواست شما برای تاریخ های زیر ثبت شده است
                </div>
              ) : (
                <div
                  className="iranyekanwebmedium"
                  style={{ textAlign: "center" }}
                >
                  {" "}
                  تاریخ های زیر برای شما ثبت شده است
                </div>
              )}
              {this.state.userReservedItem.map((item, index) => {
                return (
                  <div
                    className="iranyekanwebmedium"
                    style={{ textAlign: "center" }}
                  >
                    {item.day}{" "}
                    <i
                      style={{ color: "green", fontSize: 11, marginLeft: 10 }}
                      className="fas fa-check"
                    />
                  </div>
                );
              })}
              {this.state.IsConfirm &&
                this.state.userReservedItem[0] &&
                !this.state.userReservedItem[0].SystemConfirmed && (
                  <div
                    className="iranyekanwebmedium"
                    style={{ textAlign: "center" }}
                  >
                    {" "}
                    لطفا تا دریافت نتیجه درخواست منتظر باشید
                  </div>
                )}
            </div>
          </div>
        )}
        {this.state.showDiv != 0 &&
          this.state.IsConfirm &&
          this.state.userReservedItem.length > 0 && (
            <div
              style={{ backgroundColor: "#eee", color: "#000", marginTop: 10 }}
            >
              <div>
                <div
                  className="iranyekanwebmedium"
                  style={{ textAlign: "center" }}
                >
                  درخواست شما برای تاریخ های زیر ثبت شده است
                </div>
              </div>

              <div style={{ paddingLeft: 5, paddingRight: 5 }}>
                {this.state.userReservedItem.map((item, index) => {
                  return item.SystemConfirmed ? (
                    <div>
                      <div
                        className="iranyekanwebmedium"
                        style={{
                          textAlign: "center",
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        {" "}
                        {item.UserConfirmed ? (
                          <span
                            style={{
                              color: "#00d200",
                              width: "30%",
                              textAlign: "left",
                              fontSize: 13,
                              border: "1px solid #ccc",
                            }}
                          >
                            پرداخت شده
                          </span>
                        ) : (
                          <span
                            style={{
                              color: "red",
                              width: "30%",
                              textAlign: "left",
                              fontSize: 13,
                              border: "1px solid #ccc",
                            }}
                          >
                            پرداخت نشده
                          </span>
                        )}
                        <span
                          style={{
                            color: "#00d200",
                            width: "40%",
                            textAlign: "right",
                            fontSize: 13,
                            border: "1px solid #ccc",
                          }}
                        >
                          تایید شده توسط سیستم
                        </span>
                        <span
                          style={{
                            width: "30%",
                            textAlign: "right",
                            fontSize: 13,
                            border: "1px solid #ccc",
                          }}
                        >
                          {item.day.replaceAll("_", "/")}
                        </span>
                      </div>
                    </div>
                  ) : (
                    <div
                      className="iranyekanwebmedium"
                      style={{
                        textAlign: "center",
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <span
                        style={{
                          color: "red",
                          width: "30%",
                          textAlign: "left",
                          fontSize: 13,
                          border: "1px solid #ccc",
                        }}
                      ></span>
                      <span
                        style={{
                          color: "blue",
                          width: "40%",
                          textAlign: "right",
                          fontSize: 13,
                          border: "1px solid #ccc",
                        }}
                      >
                        منتظر تایید سیستم
                      </span>
                      <span
                        style={{
                          width: "30%",
                          textAlign: "right",
                          fontSize: 13,
                          border: "1px solid #ccc",
                        }}
                      >
                        {item.day.replaceAll("_", "/")}
                      </span>{" "}
                    </div>
                  );
                })}
              </div>
            </div>
          )}
        <Dialog
          header="تایید رزرو"
          visible={this.state.ReserveDialog}
          maximized={true}
          onHide={() => {
            this.setState({
              ReserveDialog: false,
              OffCodeAccept: false,
              offCode : ""
            });
          }}
        >
          {!this.state.ShowLoading ? (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              {this.props.username ? (
                <div >
                  <div style={{width: '100%',textAlign: "center"}}>
                    <span className="iranyekanwebmedium">نام : </span>{" "}
                    <span className="iranyekanwebmedium">
                      {this.props.fullname}
                    </span>
                  </div>
                  <div style={{ marginBottom: 20, width: '100%',textAlign: "center" }}>
                    <span className="iranyekanwebmedium">تلفن تماس : </span>{" "}
                    <span className="iranyekanwebmedium">
                      {this.props.mobile}
                    </span>
                  </div>
                </div>
              ) : (
                <div style={{ width: "100%", marginBottom: 50 }}>
                  <div
                    style={{
                      marginTop: 35,
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    <input
                      autocomplete="off"
                      className="form-control iranyekanwebmedium"
                      disabled={this.state.SystemConfirmed}
                      style={{
                        textAlign: "center",
                        width: "100%",
                        background: "transparent",
                        border: 0,
                        borderBottom: "1px solid #000",
                        height: 40,
                      }}
                      type="text"
                      id="UserFullName"
                      value={this.state.UserFullName}
                      name="UserFullName"
                      onChange={(e) =>
                        this.setState({ UserFullName: e.target.value })
                      }
                      required
                    />
                    <label
                      className="iranyekanwebmedium"
                      style={{ position: "absolute", right: 5, fontSize:12 }}
                    >
                      نام و نام خانوادگی
                    </label>
                  </div>
                  <div
                    style={{
                      marginTop: 35,
                      display: "flex",
                      justifyContent: "space-around",
                      width: "100%",
                      position: "relative",
                    }}
                  >
                    <input
                      autocomplete="off"
                      className="form-control iranyekanwebmedium"
                      disabled={this.state.SystemConfirmed}
                      style={{
                        textAlign: "center",
                        width: "100%",
                        background: "transparent",
                        border: 0,
                        borderBottom: "1px solid #000",
                        height: 40,
                      }}
                      type="number"
                      id="UserMobile"
                      value={this.state.UserMobile}
                      name="UserMobile"
                      onChange={(e) =>
                        this.setState({ UserMobile: e.target.value })
                      }
                      required
                    />
                    <label
                      className="iranyekanwebmedium"
                      style={{ position: "absolute", right: 5, fontSize:12 }}
                    >
                      تلفن همراه
                    </label>
                  </div>
                </div>
              )}
              {this.state.GridDataReserve && (
                <div style={{ marginBottom: 20 }}>
                  <span className="iranyekanwebmedium">رزرو </span>{" "}
                  <span className="iranyekanwebmedium">
                    {this.state.GridDataReserve.name}
                  </span>
                </div>
              )}

              {this.state.userChecked &&
                this.state.userChecked.map((item, index) => {
                  if (
                    item.old != "1" ||
                    (item.SystemConfirmed && !item.UserConfirmed)
                  ) {
                    return (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          direction: "rtl",
                        }}
                      >
                        <div
                          className="iranyekanwebmedium"
                          style={{
                            width: "50%",
                            border: "1px solid #eee",
                            padding: 5,
                          }}
                        >
                          {item.Day} {item.Mounth} {item.Year}
                        </div>
                        <div
                          className="iranyekanwebmedium"
                          style={{
                            width: "50%",
                            border: "1px solid #eee",
                            padding: 5,
                          }}
                        >
                          {item.price
                            .toString()
                            .replace(/,/g, "")
                            .replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                          ریال
                        </div>
                      </div>
                    );
                  }
                })}

              {(!this.state.IsConfirm || this.state.SystemConfirmed) && (
                <div style={{ width: "100%", textAlign: "center", marginTop:35 }}>
                  {this.state.AccList && this.state.AccList.length > 0 && (
                    <Dropdown
                      style={{ width: "90%", textAlign: "right" }}
                      value={this.state.AccountNumber}
                      options={this.state.AccList}
                      onChange={(e) =>
                        this.setState({
                          AccountNumber: e.value,
                          AccDialog: false,
                        })
                      }
                      placeholder="حساب خود را انتخاب کنید"
                    />
                  )}
                  {/*this.state.AccountNumber !== "zarinpal" && (
                    <p
                      className="iranyekanwebmedium"
                      style={{ direction: "rtl" }}
                    >
                      {" "}
                      {this.state.AccountNumber}
                    </p>
                  )*/}
                </div>
              )}
              <div style={{width: '100%', display: 'flex', justifyContent: 'space-between', marginTop:30, marginBottom:30, alignItems: 'center'}}>
                 <div>
                    <Button onClick={()=>{
                      this.setOffCode();
                    }} disabled={(!this.state.UserMobile && !this.props.mobile) || this.state.OffCodeAccept} style={{fontSize:13, padding: 3, fontFamily: 'iranyekanwebmedium'}} className="iranyekanwebmedium p-button-success">
                      بررسی و اعمال
                    </Button>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-around",
                      width: "70%",
                      position: "relative",
                    }}
                  >
                    <input
                      autocomplete="off"
                      className="form-control iranyekanwebmedium"
                      style={{
                        textAlign: "center",
                        width: "100%",
                        background: "transparent",
                        border: 0,
                        borderBottom: "1px solid #000",
                        height: 40,
                      }}
                      type="text"
                      id="offCode"
                      value={this.state.offCode}
                      name="offCode"
                      onChange={(e) =>
                        this.setState({ offCode: e.target.value, OffCodeAccept : false, Price : this.state.OriginalPrice || this.state.Price })
                      }
                      disabled={!this.state.UserMobile && !this.props.mobile}
                    />
                    <label
                      className="iranyekanwebmedium"
                      style={{ position: "absolute", right: 5, fontSize:12 }}
                    >
                     کد تخفیف
                    </label>
                  </div>
                  
              </div>

              
              <p
                className="iranyekanwebmedium"
                style={{ direction: "rtl", fontSize: 20, color: "#440707" }}
              >
                مبلغ قابل پرداخت :
                {this.state.Price.toString()
                  .replace(/,/g, "")
                  .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                }
                ریال
              </p>
                {this.state.OffCodeAccept && 
                  <span
                  className="iranyekanwebmedium"
                  style={{ direction: "rtl", fontSize: 14, color: "green" }}
                >
                    تخفیف:
                  {this.state.offAmount.toString()
                    .replace(/,/g, "")
                    .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                  }
                  ریال
                </span>
                }
              <Button
                info
                rounded
                style={{
                  marginTop: 10,
                  marginLeft: 10,
                  marginRight: 10,
                  marginBottom: 10,
                  padding: 10,
                  textAlign: "center",
                }}
                onClick={() => this.SetReserve(1, 0 , this.state.userChecked)}
              >
                {!this.state.IsConfirm || this.state.SystemConfirmed ? (
                  <span
                    style={{
                      fontFamily: "iranyekanwebmedium",
                      fontSize: 15,
                      width: "100%",
                    }}
                  >
                    پرداخت و تایید
                  </span>
                ) : (
                  <span
                    style={{
                      fontFamily: "iranyekanwebmedium",
                      fontSize: 15,
                      width: "100%",
                    }}
                  >
                    درخواست رزرو
                  </span>
                )}
              </Button>
            </div>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100%",
              }}
            >
              <ProgressSpinner
                style={{ width: "50px", height: "50px" }}
                strokeWidth="2"
                fill="var(--surface-ground)"
                animationDuration=".5s"
              />
            </div>
          )}
        </Dialog>

        {!this.state.ShowLoading ? (
          <div>
            <div
              style={{
                textAlign: "center",
                display: "flex",
                justifyContent: "center",
                marginTop: 20,
              }}
            >
              <div style={{ width: "95%" }}>
                {this.state.GridDataReserve && (
                  <Swiper {...params5}>
                    <div>
                      <img
                        src={
                          this.state.absoluteUrl +
                          (this.state.GridDataReserve.pic
                            ? this.state.GridDataReserve.pic?.split("public")[1]
                            : "nophoto.png")
                        }
                        style={{
                          borderRadius: 12,
                          whiteSpace: "pre-wrap",
                          maxHeight: 220,
                          width: "100%",
                        }}
                      />
                    </div>
                    <div>
                      <img
                        src={
                          this.state.absoluteUrl +
                          (this.state.GridDataReserve.extraPic1
                            ? this.state.GridDataReserve.extraPic1?.split(
                                "public"
                              )[1]
                            : "nophoto.png")
                        }
                        style={{
                          borderRadius: 12,
                          whiteSpace: "pre-wrap",
                          maxHeight: 220,
                          width: "100%",
                        }}
                      />
                    </div>
                    <div>
                      <img
                        src={
                          this.state.absoluteUrl +
                          (this.state.GridDataReserve.extraPic2
                            ? this.state.GridDataReserve.extraPic2?.split(
                                "public"
                              )[1]
                            : "nophoto.png")
                        }
                        style={{
                          borderRadius: 12,
                          whiteSpace: "pre-wrap",
                          maxHeight: 220,
                          width: "100%",
                        }}
                      />
                    </div>
                    <div>
                      <img
                        src={
                          this.state.absoluteUrl +
                          (this.state.GridDataReserve.extraPic3
                            ? this.state.GridDataReserve.extraPic3?.split(
                                "public"
                              )[1]
                            : "nophoto.png")
                        }
                        style={{
                          borderRadius: 12,
                          whiteSpace: "pre-wrap",
                          maxHeight: 220,
                          width: "100%",
                        }}
                      />
                    </div>
                    <div>
                      <img
                        src={
                          this.state.absoluteUrl +
                          (this.state.GridDataReserve.extraPic4
                            ? this.state.GridDataReserve.extraPic4?.split(
                                "public"
                              )[1]
                            : "nophoto.png")
                        }
                        style={{
                          borderRadius: 12,
                          whiteSpace: "pre-wrap",
                          maxHeight: 220,
                          width: "100%",
                        }}
                      />
                    </div>
                  </Swiper>
                )}
              </div>
            </div>
            <div>
              <div style={{ padding: 20, textAlign: "center" }}>
                {this.state.GridDataReserve && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      flexDirection: "column",
                    }}
                  >
                    <div
                      className="iranyekanwebmedium"
                      style={{ textAlign: "center", fontSize: 18 }}
                    >
                      {this.state.GridDataReserve.name}
                    </div>
                    <div
                      className="iranyekanwebmedium"
                      style={{
                        textAlign: "right",
                        whiteSpace: "pre-wrap",
                        padding: 5,
                        fontSize: 15,
                        direction: "rtl",
                      }}
                    >
                      {this.state.GridDataReserve.desc}
                    </div>
                    <div
                      className="iranyekanwebmedium"
                      style={{
                        marginTop: 20,
                        textAlign: "right",
                        fontSize: 15,
                        direction: "rtl",
                        marginRight: 10,
                      }}
                    >
                      <span> حداکثر تعداد شب اقامت : </span>{" "}
                      <span> {this.state.GridDataReserve.maxDay} شب </span>
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div
              className="no-scroll-bar"
              style={{
                display: "inline",
                flexWrap: "wrap",
                overflow: "auto",
                direction: "rtl",
              }}
            >
              {this.state.mounth.map((item, index) => {
                
                let key = this.state.key[index];
                let prev = index - 1;
                let next = index + 1;
                return (
                  this.state.Mounth &&
                  this.state.showDiv == index && (
                    <div
                      style={{
                        textAlign: "center",
                        padding: 10,
                        position: "relative",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "baseline",
                        }}
                      >
                        {index != 0 ? (
                          <div>
                            <i
                              className="fas fa-angle-double-right"
                              onClick={() => {
                                this.setState({
                                  showDiv: prev,
                                });
                              }}
                            />
                          </div>
                        ) : (
                          <div>
                            <i />
                          </div>
                        )}
                        <div>
                          <p
                            className="iranyekanwebmedium"
                            style={{ textAlign: "center" }}
                          >
                            {this.state.mounth[index]}
                          </p>
                        </div>
                          <div>
                            <i
                              className="fas fa-angle-double-left"
                              onClick={() => {
                                this.setState({
                                  showDiv: next < 12 ? next : 0 ,
                                });
                              }}
                            />
                          </div>
                        
                      </div>
                      <div></div>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "flex-end",
                          flexWrap: "wrap",
                        }}
                      >
                        {this.state.Mounth[key] &&
                          this.state.Mounth[key].length > 0 &&
                          this.state.Mounth[key].map((item, index) => {
                            return (
                              <Popover
                                title={item.priceWord + " تومان"}
                                overlayStyle={{textAlign:'center',fontSize:12,paddingRight:100}}
                                placement="top"
                                trigger="focus"
                              >
                              <ToggleButton
                                style={{
                                  width: "25%",
                                  direction: "rtl",
                                  fontSize: 12,
                                  color:
                                    item.weekName == "5" || item.free
                                      ? "red"
                                      : "auto",
                                }}
                                checked={item.checked}
                                disabled={
                                  (item.checked && !item.userChecked) ||
                                  !this.state.Allow ||
                                  (this.state.CYear == item.Year &&
                                    this.state.CMounth == item.MounthNum &&
                                    this.state.CDay > item.Day) ||
                                  (this.state.CYear == item.Year &&
                                    this.state.CMounth > item.MounthNum) ||
                                  this.state.CYear > item.Year ||
                                  (this.state.IsConfirm &&
                                    this.state.RemainPayment)
                                }
                                offLabel={item.label}
                                onLabel={item.label}
                                onChange={(e) => {
                                  let checkedCount =
                                    this.state.checkedCount || 0;
                                  if (
                                    parseInt(
                                      this.state.GridDataReserve.maxDay
                                    ) <= checkedCount &&
                                    e.value
                                  )
                                    return;
                                  item.checked = e.value;
                                  item.userChecked = e.value;
                                  checkedCount = e.value
                                    ? checkedCount + 1
                                    : checkedCount - 1;
                                  let userChecked = this.state.userChecked;
                                  if (e.value) userChecked.push(item);
                                  else {
                                    userChecked.splice(
                                      userChecked.indexOf(item),
                                      1
                                    );
                                  }
                                  // localStorage.setItem(
                                  //   "userChecked",
                                  //   JSON.stringify(userChecked)
                                  // );
                                  this.setState({
                                    checkedCount: checkedCount,
                                    userChecked: userChecked,
                                  });
                                }}
                                className="sarv-reserve-button"
                              />
                              </Popover>
                              
                            );
                          })}
                      </div>
                    </div>
                  )
                );
              })}
              {this.state.GridDataReserve && (
                <div style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    info
                    rounded
                    style={{
                      marginTop: 10,
                      marginLeft: 10,
                      marginRight: 10,
                      marginBottom: 10,
                      padding: 10,
                      textAlign: "center",
                    }}
                    onClick={() => this.SetReserve(0,0, this.state.userChecked)}
                  >
                    <span
                      style={{
                        fontFamily: "iranyekanwebmedium",
                        fontSize: 15,
                        width: "100%",
                      }}
                    >
                      ادامه
                    </span>
                  </Button>
                </div>
              )}
            </div>
          </div>
        ) : (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100%",
            }}
          >
            <ProgressSpinner
              style={{ width: "50px", height: "50px" }}
              strokeWidth="2"
              fill="var(--surface-ground)"
              animationDuration=".5s"
            />
          </div>
        )}
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    username: state.username,
    password: state.password,
    ip: state.ip,
    account: state.account,
    place: state.place,
    fullname: state.fullname,
    tokenrb: state.tokenrb,
    mobile: state.mobile,
    appData: state.appData,
    systemId: state.systemId,

  };
}
export default connect(mapStateToProps)(Reserve);
